class DrawerMobileMenu extends HTMLElement {
    constructor() {
        super();

        this.dropdownTriggers = this.querySelectorAll('[data-mobile-dropdown-trigger]');
        this.dropdownMenu = this.querySelectorAll('[data-mobile-dropdown-menu]');

        this.openDropdown();
    }

    openDropdown() {
        let dropdownTriggers = this.dropdownTriggers;
        dropdownTriggers.forEach(dropdownTrigger => {
            dropdownTrigger.addEventListener("click", function (e){
                console.log('click');

                dropdownTriggers.forEach(trigger => {
                    if(e.target !== trigger){
                        trigger.classList.remove('is--visible');
                    }
                })
                this.classList.toggle('is--visible');

            })
            
        });
        
    }
}

customElements.define('drawer-mobile-menu', DrawerMobileMenu);
